import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../services/endpoints/endpoints.service";

export const useUpdateChecklistOverride = () => {
	const queryClient = useQueryClient();

	const mutateCacheElement = (oldData: any, variables: any) => {
		if (oldData) {
			const updatedData = oldData.map((checklist: any) => {
				if (checklist.id === variables.checkListId) {
					return {
						...checklist,
					};
				}
				return checklist;
			});
			return updatedData;
		}
	};

	return useMutation({
		onMutate: (variables) => {
			queryClient.cancelQueries({
				queryKey: ["checklists"],
			});
			const previousData = queryClient.getQueryData(["checklists"]);
			queryClient.setQueryData(["checklists"], (oldData: any) => {
				return mutateCacheElement(oldData, variables);
			});
			return previousData;
		},
		onError: (error, variables, context) => {
			console.error("Error updating checklist:", error);
			queryClient.setQueryData(["checklists"], context);
		},
		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: ["checklists"],
			});
		},
		mutationFn: async ({
			checkListId: checklistId,
			patientId,
			applicable,
		}: {
			checkListId: number;
			patientId: number;
			applicable: boolean;
		}) => {
			await EndpointsService.dataRetriever.updateChecklistOverride({
				checkListId: checklistId,
				body: {
					patientId,
					applicable,
				},
				config: {
					params: {
						patientId,
					},
				},
			});
		},
	});
};
